var _clipPath, _use, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    xmlns: "http://www.w3.org/2000/svg",
    height: 28,
    id: "screenshot-8f439076-85d5-80e8-8008-15977cb7cefa",
    viewBox: "11253 -251 28 28",
    style: {
      WebkitPrintColorAdjust: ":exact"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shape-8f439076-85d5-80e8-8008-15977cb7cefa",
    rx: 0,
    ry: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-8f439076-85d5-80e8-8008-15977cb7cefb"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-8f439076-85d5-80e8-8008-15977cb7cefb"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 11267,
    cy: -237,
    rx: 14,
    ry: 14,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      fill: "#B1B2B5",
      fillOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "strokes-a7f21d7c-edff-80ea-8008-788760bfc130-8f439076-85d5-80e8-8008-15977cb7cefb",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "inner-stroke-shape",
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("defs", null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "inner-stroke-render-1471-8f439076-85d5-80e8-8008-15977cb7cefb-0"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#stroke-shape-render-1471-8f439076-85d5-80e8-8008-15977cb7cefb-0"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11267,
    cy: -237,
    rx: 14,
    ry: 14,
    style: {
      fill: "none",
      fillOpacity: "none",
      strokeWidth: 2.4,
      stroke: "#e97807",
      strokeOpacity: 1
    },
    id: "stroke-shape-render-1471-8f439076-85d5-80e8-8008-15977cb7cefb-0"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#stroke-shape-render-1471-8f439076-85d5-80e8-8008-15977cb7cefb-0",
    clipPath: "url('#inner-stroke-render-1471-8f439076-85d5-80e8-8008-15977cb7cefb-0')"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "shape-8f439076-85d5-80e8-8008-15977cb7cefc",
    rx: 0,
    ry: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-8f439076-85d5-80e8-8008-15977cb7cefd"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-8f439076-85d5-80e8-8008-15977cb7cefd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11261.6162109375,-231.974365234375L11273.103515625,-242.025634765625"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "strokes-a7f21d7c-edff-80ea-8008-788760c014cd-8f439076-85d5-80e8-8008-15977cb7cefd",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11261.6162109375,-231.974365234375L11273.103515625,-242.025634765625",
    style: {
      fill: "none",
      fillOpacity: "none",
      strokeWidth: 1.2,
      stroke: "#e97807",
      strokeOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shape-8f439076-85d5-80e8-8008-15977cb7cefe"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-8f439076-85d5-80e8-8008-15977cb7cefe"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11265.923828125,-243.4615478515625L11273.2138671875,-242.217041015625L11273.2470703125,-241.770263671875L11273.2998046875,-241.0563507080078L11273.8203125,-234.12820434570312"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "strokes-a7f21d7c-edff-80ea-8008-788760c014ce-8f439076-85d5-80e8-8008-15977cb7cefe",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11265.923828125,-243.4615478515625L11273.2138671875,-242.217041015625L11273.2470703125,-241.770263671875L11273.2998046875,-241.0563507080078L11273.8203125,-234.12820434570312",
    style: {
      fill: "none",
      fillOpacity: "none",
      strokeWidth: 1.2,
      stroke: "#e97807",
      strokeOpacity: 1
    }
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowOrange);
export default __webpack_public_path__ + "static/media/ArrowOrange.0ae7b5bf76399dac403ceeba2a1af1b9.svg";
export { ForwardRef as ReactComponent };